import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  getNewbuildingNameByIdSelector,
  getNewbuildingUrlByIdSelector,
  getNewbuildingFZ214Selector,
  getNewbuildingSpecialStatusDisplaySelector,
  getNewbuildingOfferTypesSelector,
  getNewbuildingFirstMaterialSelector,
} from '../../selectors/newbuilding';
import { Link, UIHeading4 } from '@cian/ui-kit';
import { MIDDLE_DOT, NO_BREAK_SPACE } from '../../constants/symbolsUnicode';
import { NewbuildingInfo } from '../../components/NewbuildingInfo/NewbuildingInfo';
import { replaceSpacesToNbsp } from '../../utils/text/replaceSpacesToNbsp';

interface INewbuildingInfoProps {
  newbuildingId: number;
  onCardClick(offerId: number): void;
  hovered: boolean;
}

export const NewbuildingInfoContainer = (props: INewbuildingInfoProps) => {
  const { newbuildingId, onCardClick, hovered } = props;
  const name = useSelector(getNewbuildingNameByIdSelector(newbuildingId));
  const url = useSelector(getNewbuildingUrlByIdSelector(newbuildingId));
  const isFZ214 = useSelector(getNewbuildingFZ214Selector(newbuildingId));
  const specialStatusDisplay = useSelector(getNewbuildingSpecialStatusDisplaySelector(newbuildingId));
  const offerTypes = useSelector(getNewbuildingOfferTypesSelector(newbuildingId));
  const firstMaterial = useSelector(getNewbuildingFirstMaterialSelector(newbuildingId));

  const facts = React.useMemo(() => {
    let result = replaceSpacesToNbsp(specialStatusDisplay);
    if (offerTypes) {
      result += `${NO_BREAK_SPACE}${MIDDLE_DOT} ${replaceSpacesToNbsp(offerTypes)}`;
    }
    if (firstMaterial?.name) {
      result += `${NO_BREAK_SPACE}${MIDDLE_DOT} ${replaceSpacesToNbsp(firstMaterial.name)}`;
    }
    if (isFZ214) {
      result += `${NO_BREAK_SPACE}${MIDDLE_DOT} оформление${NO_BREAK_SPACE}по${NO_BREAK_SPACE}214-ФЗ`;
    }

    return result;
  }, [specialStatusDisplay, offerTypes, firstMaterial, isFZ214]);

  const handleClick = React.useCallback(() => {
    onCardClick(newbuildingId);
  }, [onCardClick, newbuildingId]);

  return (
    <NewbuildingInfo
      title={
        <Link
          href={url}
          target="_blank"
          fontSize="XXL"
          fontWeight="bold"
          onClick={handleClick}
          color={hovered ? 'default' : 'current_color'}
        >
          {name}
        </Link>
      }
      description={<UIHeading4>{facts}</UIHeading4>}
    />
  );
};
